module.exports = __webpack_public_path__ + "img/delect.95fcc22d.svg";